/**
 * Smooth open/close animation for the vertical sidebar filter accordions
 * (Size Tool, Size Category, Collection, Color Pattern, Material, etc).
 *
 * Native <details>/<summary> has no built-in transition -- it snaps open
 * and closed instantly. This progressively enhances that with a
 * max-height/opacity animation, while leaving the underlying <details>
 * "open" attribute as the source of truth so behavior degrades gracefully
 * if JS fails to load.
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.facets__disclosure-vertical').forEach(function (details) {
        var summary = details.querySelector(':scope > summary');
        var panel = details.querySelector(':scope > .facets__display-vertical');
        if (!summary || !panel) return;

        panel.style.overflow = 'hidden';
        panel.style.transition = 'max-height 0.35s ease, opacity 0.3s ease';

        if (details.hasAttribute('open')) {
            panel.style.maxHeight = 'none';
            panel.style.opacity = '1';
        } else {
            panel.style.maxHeight = '0px';
            panel.style.opacity = '0';
        }

        summary.addEventListener('click', function (e) {
            e.preventDefault();
            var isOpen = details.hasAttribute('open');

            if (isOpen) {
                // Lock current height first so the transition has a start point,
                // then animate down to 0 on the next frame.
                panel.style.maxHeight = panel.scrollHeight + 'px';
                requestAnimationFrame(function () {
                    panel.style.maxHeight = '0px';
                    panel.style.opacity = '0';
                });
                panel.addEventListener('transitionend', function handler(evt) {
                    if (evt.propertyName !== 'max-height') return;
                    details.removeAttribute('open');
                    panel.removeEventListener('transitionend', handler);
                });
            } else {
                details.setAttribute('open', '');
                panel.style.opacity = '1';
                panel.style.maxHeight = panel.scrollHeight + 'px';
                panel.addEventListener('transitionend', function handler(evt) {
                    if (evt.propertyName !== 'max-height') return;
                    // Release the fixed height afterward so "Show more" reveals,
                    // window resizes, etc. aren't clipped.
                    panel.style.maxHeight = 'none';
                    panel.removeEventListener('transitionend', handler);
                });
            }
        });

        // If "Show more" reveals additional items while this panel is open,
        // recalculate so the extra items aren't clipped.
        var showMoreBtn = details.querySelector('show-more-button button');
        if (showMoreBtn) {
            showMoreBtn.addEventListener('click', function () {
                setTimeout(function () {
                    if (details.hasAttribute('open')) {
                        panel.style.maxHeight = 'none';
                    }
                }, 50);
            });
        }
    });
});